import React, { FC, useEffect } from "react";
import { Trans, useTranslation } from "i18n";
import { Button } from "component-library";
import { HeapCustomEvent, HeapService } from "shared-services";
import applicationMap from "services/applicationMap";

const ForbiddenRequest: FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    HeapService.track(HeapCustomEvent.TapeRequestForbidden);
  }, []);

  return (
    <div className="flex flex-col m-auto items-center justify-center text-center px-4">
      <h1 className="mb-6 font-normal">
        {t("common:selfTapes.request.forbidden.title")}
      </h1>
      <div>
        <p className="mb-6">
          {t("common:selfTapes.request.forbidden.contactAgent")}
        </p>
        <p className="mb-5">
          {t("common:selfTapes.request.forbidden.notSent")}
        </p>
        <p className="mb-5">
          <Trans i18nKey="common:selfTapes.request.forbidden.noAccess" />
        </p>
        <p className="mb-10">
          <Trans
            i18nKey="common:selfTapes.request.forbidden.checkFaq"
            components={{
              a: (
                <a
                  href="https://support.spotlight.com/hc/en-us/articles/35256987011341-Performer-Support-Self-Tape-Request-FAQs-for-Represented-Performers"
                  rel="noreferrer"
                  target="_blank"
                  aria-label="FAQ"
                />
              ),
            }}
          />
        </p>
      </div>
      <Button
        className="w-auto"
        type="primary"
        text={t("common:selfTapes.request.forbidden.return")}
        href={applicationMap.links.jobsMyFilters()}
      />
    </div>
  );
};

export default ForbiddenRequest;
